import React, { useState } from 'react';
import { pick } from 'ramda';

import { SvgIcon } from '@interlayer/js/app/components/common/SvgIcon';
import { GameLayout } from '@interlayer/js/app/components/main/Games/components/GameLayout';

import { useTranslations } from '@core/js/hooks/i18n';
import { useAppSelector } from '@core/js/store/hooks';

import { DEFAULT_ANALITICS_FEED_NAMES } from '@interlayer/js/app/hooks/analiticsSubscribe/constants';
import { useRecentlyGamesSelector } from '@interlayer/js/app/store/hooks/useRecentlyGames';
import { clsx } from '@interlayer/js/app/utils/clsx.util';
import { useIsShowTag } from '@interlayer/js/components/system/App/buzz/hooks/useIsShowTag';
import { TAG_TYPE_BUZZ } from '@interlayer/js/components/system/TagManager/buzz/constants';

import { TRecentlyBlockTypes } from './types';

import style from '@interlayer/js/app/components/main/StickyFooter/StickyFooter.scss';

export const RecentlyBlock: React.FC<TRecentlyBlockTypes> = ({
    isFixed = false,
    withBands,
    withJackpots,
    withInfo,
    refEl,
    classNames = {}
}) => {
    const { gamesConfiguration = {}, isShowPlayBingoButton } = useAppSelector(pick(['gamesConfiguration', 'isShowPlayBingoButton']));
    const translate = useTranslations('playtech.mobile.system.stickyFooter.recently.');
    const { recentlyPlayedLoading, recentlyPlayedGames } = useRecentlyGamesSelector();
    const [isRecentlyOpened, setRecentlyOpened] = useState(false);
    const isShowBottomMenu = useIsShowTag(TAG_TYPE_BUZZ.bottomNavigation);

    const recentlyGameList = recentlyPlayedGames
        .map(gameCode => ({ ...gamesConfiguration[gameCode], viewMode: 'detailed' }))
        .filter(gameObj => gameObj?.gameCode);

    const handleRecentlyClick = () => {
        setRecentlyOpened(!isRecentlyOpened);
    };

    if (recentlyPlayedLoading || !recentlyGameList?.length) {
        return null;
    }

    return (
        <>
            <div
                ref={refEl}
                className={clsx(
                    style.recentlyButton,
                    classNames.recentlyButton,
                    {
                        [style.recentlyOpened]: isRecentlyOpened,
                        [style.isFixedButton]: isFixed,
                        [style.withPlayButton]: isShowPlayBingoButton,
                        [style.withBottomMenu]: isShowBottomMenu
                    }
                )}
                onClick={handleRecentlyClick}
            >
                {translate('cta')}

                <SvgIcon color="white-const-color" className={style.recentlyIcon} type="arrow-down" />
            </div>

            <div
                className={clsx(
                    style.recentlyBlock,
                    { [style.recentlyBlockOpened]: isRecentlyOpened },
                    { [style.hidden]: !isRecentlyOpened },
                    { [style.isFixedBlock]: isFixed }
                )}
            >
                {/* @ts-ignore delete after GameLayout is ts file */}

                <GameLayout
                    gameList={recentlyGameList}
                    classNames={{
                        gameTile: style.gameTile,
                        scrollContainer: style.scrollContainer,
                        gameName: style.gameName,
                        infoFavourite: style.infoFavourite,
                        infoIcon: style.infoIcon,
                        playButton: style.playButton,
                        wrapper: style.scrollerWrapper
                    }}
                    viewModeInline
                    isShowJackpots={withJackpots}
                    isShowInfo={withInfo}
                    withBands={withBands}
                    isShowFavourites
                    isShowSashes={false}
                    feedName={DEFAULT_ANALITICS_FEED_NAMES.recently}
                />
            </div>
        </>
    );
};
